import * as React from "react";
import { ReactNode } from "react";
import "./FormSection.scss";
import Form, { FormProps } from "./Form";

export default class FormWithSections extends React.PureComponent<FormProps> {
  render() {
    let sectionCount = 0;
    const children = React.Children.toArray(this.props.children)
      .filter((c) => c)
      .map((c) => {
        if (this.isFormSection(c)) {
          sectionCount++;
          return <FormSection {...c.props} number={sectionCount} key={sectionCount} />;
        } else {
          return c;
        }
      });

    return <Form {...this.props}>{children}</Form>;
  }

  private isFormSection(component): component is FormSection {
    return component.type === FormSection;
  }
}

interface FormSectionProps {
  children?: ReactNode;
  title: string;
  number?: number;
}

export class FormSection extends React.PureComponent<FormSectionProps> {
  render() {
    return (
      <div className="form-section">
        <div className="section-header">
          {this.props.number && <span className="number">{this.props.number}</span>}
          <span className="title">{this.props.title}</span>
        </div>
        {this.props.children}
      </div>
    );
  }
}
